import React from "react";
import {FieldError, useWatch} from "react-hook-form";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {mb, mt, p} from "@pg-design/helpers-css-strings";
import {CheckboxControlled, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {InputField} from "@pg-design/rhf-controllers-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {useAppDispatch} from "../../../store/hooks";
import {setForYouUser} from "../../state/for_you_modal_slice";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";
import {ForYouModalButton} from "../modal_parts/ForYouModalButton";

interface IProps {
    submitHandler: SubmitHandlerType;
    onNextStep: () => void;
    onSubmitError?: (name: string, error: FieldError) => void;
}

export const ForYouUserForm = (props: IProps) => {
    const codes = useSelector((state: IRPStore) => state.variables.data?.country_codes);
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();
    const name = useWatch({name: "name"});
    const email = useWatch({name: "email"});
    const phone = useWatch({name: "phone"});
    const propertyNotification = useWatch({name: "propertyNotification"});
    const financigServices = useWatch({name: "financigServices"});

    const onSubmit = () => {
        //TODO remove log after test (its for testers to check regions data that will be send)
        console.log(
            "Zapisuję dane usera:",
            `\nimię: ${name}`,
            `\nmail: ${email}`,
            `\nnumer: +${phone.code}${phone.number}`,
            `\nzgody nieruchomości: ${propertyNotification}`,
            `\nzgody kredyty: ${financigServices}`
        );
        dispatch(setForYouUser({name, email, phone, propertyNotification, financigServices}));
        props.onNextStep();
    };

    return (
        <form onSubmit={props.submitHandler(onSubmit)} css={formStyle}>
            <InputField name="name" placeholder="Imię i Nazwisko" className="for-you-user-input" />

            <InputField name="email" placeholder="e-mail" type="email" className="for-you-user-input" />

            {codes && (
                <PhoneFieldControlled
                    name="phone"
                    codes={codes}
                    placeholder="Numer telefonu"
                    className="for-you-user-input"
                    maxMenuHeight={isMobile ? 120 : 160}
                />
            )}

            <div className="permissions-checkboxes">
                <CheckboxControlled
                    name="propertyNotification"
                    id="propertyNotification"
                    labelContent={
                        <Text variant="info_txt_2">Chcę otrzymywać mailem lub SMSem linki do nowych ofert nieruchomości. Zgodę mogę zawsze odwołać.</Text>
                    }
                    checkedMarkColor="#02D054"
                />

                <CheckboxControlled
                    name="financigServices"
                    id="financigServices"
                    labelContent={<Text variant="info_txt_2">Poproszę o przedstawienie oferty kredytu na to mieszkanie.</Text>}
                    checkedMarkColor="#02D054"
                />
            </div>

            <ForYouModalButton />
        </form>
    );
};

const formStyle = css`
    width: 100%;
    ${p(3, 1.5, 0, 1.5)};
    background-color: #fff;

    .for-you-user-input {
        ${mt(1.5)};
    }

    .permissions-checkboxes {
        ${mt(2.5)};
        ${mb(3)};
    }

    .selectStyle {
        max-width: 200px;
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        background-color: ${getThemeVariable("colors.gray.100")};
        ${p(8, 5, 8, 5)};
    }
`;
import React from "react";
import {FieldError, useWatch} from "react-hook-form";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {mb, mt, p} from "@pg-design/helpers-css-strings";
import {CheckboxControlled, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {InputField} from "@pg-design/rhf-controllers-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {useAppDispatch} from "../../../store/hooks";
import {setForYouUser} from "../../state/for_you_modal_slice";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";
import {ForYouModalButton} from "../modal_parts/ForYouModalButton";

interface IProps {
    submitHandler: SubmitHandlerType;
    onNextStep: () => void;
    onSubmitError?: (name: string, error: FieldError) => void;
}

export const ForYouUserForm = (props: IProps) => {
    const codes = useSelector((state: IRPStore) => state.variables.data?.country_codes);
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();
    const name = useWatch({name: "name"});
    const email = useWatch({name: "email"});
    const phone = useWatch({name: "phone"});
    const propertyNotification = useWatch({name: "propertyNotification"});
    const financigServices = useWatch({name: "financigServices"});

    const onSubmit = () => {
        //TODO remove log after test (its for testers to check regions data that will be send)
        console.log(
            "Zapisuję dane usera:",
            `\nimię: ${name}`,
            `\nmail: ${email}`,
            `\nnumer: +${phone.code}${phone.number}`,
            `\nzgody nieruchomości: ${propertyNotification}`,
            `\nzgody kredyty: ${financigServices}`
        );
        dispatch(setForYouUser({name, email, phone, propertyNotification, financigServices}));
        props.onNextStep();
    };

    return (
        <form onSubmit={props.submitHandler(onSubmit)} css={formStyle}>
            <InputField name="name" placeholder="Imię i Nazwisko" className="for-you-user-input" />

            <InputField name="email" placeholder="e-mail" type="email" className="for-you-user-input" />

            {codes && (
                <PhoneFieldControlled
                    name="phone"
                    codes={codes}
                    placeholder="Numer telefonu"
                    className="for-you-user-input"
                    maxMenuHeight={isMobile ? 120 : 160}
                />
            )}

            <div className="permissions-checkboxes">
                <CheckboxControlled
                    name="propertyNotification"
                    id="propertyNotification"
                    labelContent={
                        <Text variant="info_txt_2">Chcę otrzymywać mailem lub SMSem linki do nowych ofert nieruchomości. Zgodę mogę zawsze odwołać.</Text>
                    }
                    checkedMarkColor="#02D054"
                />

                <CheckboxControlled
                    name="financigServices"
                    id="financigServices"
                    labelContent={<Text variant="info_txt_2">Poproszę o przedstawienie oferty kredytu na to mieszkanie.</Text>}
                    checkedMarkColor="#02D054"
                />
            </div>

            <ForYouModalButton />
        </form>
    );
};

const formStyle = css`
    width: 100%;
    ${p(3, 1.5, 0, 1.5)};
    background-color: #fff;

    .for-you-user-input {
        ${mt(1.5)};
    }

    .permissions-checkboxes {
        ${mt(2.5)};
        ${mb(3)};
    }

    .selectStyle {
        max-width: 200px;
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        background-color: ${getThemeVariable("colors.gray.100")};
        ${p(8, 5, 8, 5)};
    }
`;
